import {
    CalendarDays,
    FileText,
    MonitorDot,
    PackagePlus,
    ScrollText,
    UserRound,
    Folder,
    CheckCircle,
    Settings,
    MessageCircle,
    Building2,
    UserCog,
    Shield,
    Users,
    Clock,
    MapPin,
    ClipboardList,
    Calendar,
    Receipt,
    DollarSign,
    CreditCard,
    Cog,
    MessageSquare,
    Mail,
    HelpCircle,
    Navigation,
    AlertTriangle,
    Activity,
    QrCode
} from "lucide-react";

export const menuData: any = [
    // Dashboard Section
    {
        id: "dashboard",
        label: 'Dashboard',
        link: "/dashboard",
        icon: <MonitorDot className="text-blue-600 hover:text-blue-700 transition-colors" />,
        className: "hover:bg-blue-50 border-l-4 border-transparent hover:border-blue-500 transition-all duration-200"
    },

    // Organization Management Section
    {
        label: 'Organization',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'department-list',
        label: 'Departments',
        icon: <Building2 className="text-slate-600 hover:text-slate-700 transition-colors" />,
        link: '/departments',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-slate-50 border-l-4 border-transparent hover:border-slate-500 transition-all duration-200"
    },
    {
        id: 'designation',
        label: 'Designations',
        icon: <UserCog className="text-violet-600 hover:text-violet-700 transition-colors" />,
        link: '/designations',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-violet-50 border-l-4 border-transparent hover:border-violet-500 transition-all duration-200"
    },
    {
        id: 'role',
        label: 'Role',
        icon: <Shield className="text-rose-600 hover:text-rose-700 transition-colors" />,
        link: '/roles',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-rose-50 border-l-4 border-transparent hover:border-rose-500 transition-all duration-200"
    },
    {
        id: 'employee',
        label: 'Employee/User',
        icon: <Users className="text-emerald-600 hover:text-emerald-700 transition-colors" />,
        link: '/employees',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-emerald-50 border-l-4 border-transparent hover:border-emerald-500 transition-all duration-200"
    },

    // Communication & Collaboration Section
    {
        label: 'Communication',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'email-list',
        label: 'Emails',
        icon: <Mail className="text-sky-600 hover:text-sky-700 transition-colors" />,
        link: '/email',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-sky-50 border-l-4 border-transparent hover:border-sky-500 transition-all duration-200"
    },
    {
        id: 'engage',
        label: 'Engage',
        icon: <MessageCircle className="text-teal-600 hover:text-teal-700 transition-colors" />,
        link: '/apps-engage',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-teal-50 border-l-4 border-transparent hover:border-teal-500 transition-all duration-200"
    },
    {
        id: 'notes',
        label: 'Notes',
        icon: <ScrollText className="text-amber-600 hover:text-amber-700 transition-colors" />,
        link: '/apps-notes',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-amber-50 border-l-4 border-transparent hover:border-amber-500 transition-all duration-200"
    },
    {
        id: 'calendar',
        label: 'Calendar',
        link: '/apps-calendar',
        icon: <Calendar className="text-fuchsia-600 hover:text-fuchsia-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-fuchsia-50 border-l-4 border-transparent hover:border-fuchsia-500 transition-all duration-200"
    },

    // Attendance & Location Section
    {
        label: 'Attendance & Location',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'attendance',
        label: 'Attendance',
        icon: <Clock className="text-indigo-600 hover:text-indigo-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-indigo-50 border-l-4 border-transparent hover:border-indigo-600 transition-all duration-200",
        subItems: [
            {
                id: 'attendance-user',
                label: 'Attendance List',
                link: '/attendance',
                parentId: 'attendance',
                className: "hover:bg-indigo-100 ml-4 border-l-2 border-transparent hover:border-indigo-400 transition-all duration-200"
            },
            {
                id: 'attendance-main',
                label: 'Main Attendance',
                link: '/attendance/all',
                parentId: 'attendance',
                className: "hover:bg-indigo-100 ml-4 border-l-2 border-transparent hover:border-indigo-400 transition-all duration-200"
            },
        ]
    },
    {
        id: 'attendance-sales',
        label: 'Travel Tracker',
        link: '/attendance/sales-executives',
        icon: <MapPin className="text-pink-600 hover:text-pink-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-pink-50 border-l-4 border-transparent hover:border-pink-500 transition-all duration-200"
    },
    {
        id: 'geofence-management',
        label: 'Geofence Management',
        link: '/geofence-management',
        icon: <Navigation className="text-orange-600 hover:text-orange-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-orange-50 border-l-4 border-transparent hover:border-orange-500 transition-all duration-200"
    },
    {
        id: 'anomaly-detection',
        label: 'AI Anomaly Detection',
        link: '/anomaly-detection',
        icon: <AlertTriangle className="text-red-600 hover:text-red-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-red-50 border-l-4 border-transparent hover:border-red-500 transition-all duration-200"
    },
    {
        id: 'crashlytics',
        label: 'Crashlytics',
        link: '/crashlytics',
        icon: <Activity className="text-purple-600 hover:text-purple-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-purple-50 border-l-4 border-transparent hover:border-purple-500 transition-all duration-200"
    },
    {
        id: 'facial-recognition-approval',
        label: 'Face Reg. Approval',
        link: '/facial-recognition-approval',
        icon: <CheckCircle className="text-purple-600 hover:text-purple-700 transition-colors" />,
        parentId: 2,
        className: "hover:bg-purple-50 border-l-4 border-transparent hover:border-purple-500 transition-all duration-200"
    },
    {
        id: 'attendance-approvals',
        label: 'Attendance Approvals',
        link: '/attendance-approvals',
        icon: <CheckCircle className="text-orange-600 hover:text-orange-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-orange-50 border-l-4 border-transparent hover:border-orange-500 transition-all duration-200"
    },

    // Updates & Reports Section
    {
        label: 'Updates & Reports',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'daily-updates',
        label: 'Daily Updates',
        icon: <ClipboardList className="text-green-600 hover:text-green-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-green-50 border-l-4 border-transparent hover:border-green-600 transition-all duration-200",
        subItems: [
            {
                id: 'daily-updates-form',
                label: 'Daily Updates Form',
                link: '/daily-updates-form',
                parentId: 'daily-updates',
                className: "hover:bg-green-100 ml-4 border-l-2 border-transparent hover:border-green-400 transition-all duration-200"
            },
            {
                id: 'daily-updates-overall',
                label: 'Overall Updates',
                link: '/overall-updates',
                parentId: 'daily-updates',
                className: "hover:bg-green-100 ml-4 border-l-2 border-transparent hover:border-green-400 transition-all duration-200"
            }
        ]
    },
    {
        id: 'marketing-tools',
        label: 'Marketing Tools',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'qr-code-generator',
        label: 'QR Code Generator',
        icon: <QrCode className="text-emerald-500 hover:text-emerald-600 transition-colors" />,
        link: '/qr-code-generator',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-emerald-50 border-l-4 border-transparent hover:border-emerald-500 transition-all duration-200"
    },

    // HR Management Section
    {
        label: 'HR Management',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'leaves',
        label: 'Leave',
        icon: <CalendarDays className="text-cyan-600 hover:text-cyan-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-cyan-50 border-l-4 border-transparent hover:border-cyan-500 transition-all duration-200",
        subItems: [
            {
                id: 'leaves-form',
                label: 'Leave Form',
                link: '/apply-for-leaves',
                parentId: 'leaves',
                className: "hover:bg-cyan-100 ml-4 border-l-2 border-transparent hover:border-cyan-400 transition-all duration-200"
            },
            {
                id: 'leaves-list',
                label: 'My Leaves',
                link: '/leaves',
                parentId: 'leaves',
                className: "hover:bg-cyan-100 ml-4 border-l-2 border-transparent hover:border-cyan-400 transition-all duration-200"
            },
        ]
    },
    {
        id: 'resumes',
        label: 'Resumes',
        icon: <FileText className="text-indigo-600 hover:text-indigo-700 transition-colors" />,
        link: '/resumes',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-indigo-50 border-l-4 border-transparent hover:border-indigo-500 transition-all duration-200"
    },

    // Finance Section
    {
        label: 'Finance',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'payroll',
        label: 'Payroll',
        icon: <DollarSign className="text-yellow-600 hover:text-yellow-700 transition-colors" />,
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-yellow-50 border-l-4 border-transparent hover:border-yellow-500 transition-all duration-200",
        subItems: [
            {
                id: 'payroll-list',
                label: 'Employee Payroll',
                link: '/payroll',
                parentId: 'payroll',
                className: "hover:bg-yellow-100 ml-4 border-l-2 border-transparent hover:border-yellow-400 transition-all duration-200"
            },
            {
                id: 'salary-paid-report',
                label: 'Salary Paid Report',
                link: '/payroll/salary-paid-report',
                parentId: 'payroll',
                className: "hover:bg-yellow-100 ml-4 border-l-2 border-transparent hover:border-yellow-400 transition-all duration-200"
            }
        ]
    },

    // Feedback & Support Section
    {
        label: 'Feedback & Support',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'feedback',
        label: 'Feedback',
        icon: <MessageSquare className="text-purple-600 hover:text-purple-700 transition-colors" />,
        link: '/feedback-management',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-purple-50 border-l-4 border-transparent hover:border-purple-500 transition-all duration-200"
    },
    {
        id: 'help-support',
        label: 'Help & Support',
        icon: <HelpCircle className="text-blue-600 hover:text-blue-700 transition-colors" />,
        link: '/help-support',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-blue-50 border-l-4 border-transparent hover:border-blue-500 transition-all duration-200"
    },

    // Ticket Management Section
    {
        label: 'Ticket Management',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'my-tickets',
        label: 'My Tickets',
        icon: <FileText className="text-emerald-600 hover:text-emerald-700 transition-colors" />,
        link: '/my-tickets',
        parentId: 2,
        className: "hover:bg-emerald-50 border-l-4 border-transparent hover:border-emerald-500 transition-all duration-200"
    },
    {
        id: 'all-tickets',
        label: 'All Tickets',
        icon: <ClipboardList className="text-indigo-600 hover:text-indigo-700 transition-colors" />,
        link: '/all-tickets',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-indigo-50 border-l-4 border-transparent hover:border-indigo-500 transition-all duration-200"
    },

    // Settings Section
    {
        label: 'Settings',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'settings',
        label: 'Settings',
        icon: <Settings className="text-gray-600 hover:text-gray-700 transition-colors" />,
        link: '/companies',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-gray-50 border-l-4 border-transparent hover:border-gray-500 transition-all duration-200"
    }
];
